<template>
  <div class="background" >
     <div class="content">

     </div>
  <div class="footer">9989595656</div>
  </div>
</template>

<script>

export default {
  name: 'clearUserData'
}
</script>


<style scoped>
.background {
  position: fixed;
  width: 100%;
  height: 100%;
  background-image: url('../assets/weee.jpg');
  opacity: 0.8;
  background-size: cover;
  background-position: center;
  flex: 1;
}
.content {
  width: 100%;
  height: calc(100% - 30px);
}
.footer {
  float: bottom;
  font-family: 'montserrat', sans-serif;
  height: 30px;
  text-align: center;
}
</style>
